<template>
  <div class="row">
    <!-- <div class="col-md-12">
        <h1 class="h3 mb-3 text-gray-800">
            Situações de Violação de Direitos na Família ID #{{
                $route.params.id
            }}
        </h1>
    </div>

    <load v-if="loading" /> -->
    <header-servico
      :familia="familia.id"
      :loading="loading"
      tipo="Situações de Violação de Direitos"
    />
    <load
      v-if="loading"
      message="Carregando as Situações de Violação de Direitos da Família"
    />
    <div v-else class="col-md-12">
      <!--Tabela-->
      <div class="row">
        <sidebar-servicos active="violacaodedireito" />

        <div class="col-md-9">
          <div class="row">
            <div class="col-md-12">
              <header-familia :item="familia" />
            </div>
          </div>
          <div class="card mb-0 shadow">
            <div class="card-body">
              <div class="tab-content">
                <div v-if="!novo_vvd" class="animate__animated animate__fadeIn">
                  <div class="row">
                    <div class="col">
                      <h5 class="font-weight-bold">
                        Violação de Direitos
                        <b-link
                          v-b-popover.hover.right="info_vvd"
                          variant="info"
                        >
                          <i class="fas fa-info-circle"></i>
                        </b-link>
                      </h5>
                    </div>
                    <div class="col-12">
                      <div
                        class="d-flex align-items-center justify-content-between mb-4"
                      >
                        <div>
                          <button
                            class="btn btn-primary"
                            @click="novo_vvd = true"
                          >
                            <i class="fas fa-plus-square" />
                            {{ $t("Cadastrar") }}
                          </button>
                        </div>
                        <div>
                          <div class="input-group mb-3">
                            <b-input
                              v-model="search"
                              :placeholder="$t('Type to search')"
                              aria-describedby="input-search"
                              class="form-control search-input"
                              type="text"
                              v-on:change="getVVD"
                            />
                            <div class="input-group-append" role="button">
                              <span id="input-search" class="input-group-text"
                                ><i class="fas fa-search search-icon"
                              /></span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <load v-if="loadingVVD" mode="table" />
                    <div v-else class="col-12">
                      <span>
                        <a
                          v-if="!showName"
                          @click.prevent="mostrarNome"
                          href="#"
                          ><i class="fas fa-eye"></i> Mostrar Nome de
                          Registro</a
                        >
                        <a v-else @click.prevent="ocultarNome" href="#"
                          ><i class="fas fa-eye-slash"></i> Ocultar Nome de
                          Registro</a
                        >
                      </span>
                      <b-table
                        :fields="[
                          {
                            key: 'protocolo',
                            label: $t('Detalhes'),
                          },
                          {
                            key: 'cadastrado',
                            label: $t('Data'),
                          },
                          {
                            key: 'status_nome',
                            label: $t('Status'),
                          },
                          {
                            key: 'actions',
                            label: '',
                            class: 'text-right',
                            thStyle: {
                              width: '95px',
                              minWidth: '95px',
                            },
                          },
                        ]"
                        :items="VVDList"
                        :responsive="true"
                        hover
                        outlined
                        show-empty
                        small
                        stacked="md"
                        striped
                        table-class="mb-3"
                      >
                        <template v-slot:cell(protocolo)="data">
                          Usuário(s):<br />
                          <ul>
                            <li
                              v-for="pessoa in data.item.pessoas_objetos"
                              :key="pessoa.id"
                            >
                              <b v-if="!pessoa.nome_social">
                                {{ pessoa.nome_completo }}
                              </b>
                              <b v-else>
                                {{ pessoa.nome_social }} ( N.R.: )
                                <span v-if="showName">{{
                                  pessoa.nome_completo
                                }}</span>
                              </b>
                            </li>
                          </ul>
                          Protocolo:
                          <b>{{ data.item.protocolo }}</b>
                          <br />
                          Violações:
                          <b>
                            <a
                              v-if="data.item.violacoes_nomes.length > 0"
                              href="#"
                              @click.prevent="
                                getViolacoes(
                                  data.item.violacoes_nomes,
                                  data.item
                                )
                              "
                            >
                              Ver Situações ({{
                                data.item.violacoes_nomes.length
                              }})</a
                            >
                          </b>
                          <br />
                          Unidade:
                          <b>{{
                            data.item.unidade ? data.item.unidade.nome : ""
                          }}</b>
                          <br />
                          Técnico autor:
                          <b>{{ data.item.autor }}</b>
                          <br />
                          <b-link :id="'pophover-' + data.item.id" href="">
                            <i
                              v-if="
                                data.item.outros_tecnicos &&
                                data.item.outros_tecnicos.length > 0
                              "
                              class="mdi mdi-account-switch mdi-18px text-primary"
                            ></i>
                          </b-link>

                          <b-popover
                            :target="'pophover-' + data.item.id"
                            placement="right"
                            triggers="hover"
                          >
                            <template #title>Técnicos Participantes </template>
                            <ol>
                              <li
                                v-for="tecnico in data.item.outros_tecnicos"
                                :key="tecnico"
                              >
                                <small>{{ tecnico }}</small>
                              </li>
                            </ol>
                          </b-popover>
                        </template>
                        <template v-slot:cell(cadastrado)="data">
                          {{ data.item.cadastrado }}
                        </template>
                        <template v-slot:cell(status_nome)="data">
                          <span
                            class="small"
                            v-html="data.item.status_nome"
                          ></span>
                        </template>
                        <template v-slot:cell()="data">
                          <b-button
                            v-if="
                              (user_id !== data.item.user_id &&
                                data.item.tecnicos.indexOf(tecnico_id) != -1) ||
                              (data.item.unidade_id == unidade_id &&
                                (data.item.user_role ==
                                  'Técnico(a) Administrativo(a)' ||
                                  data.item.user_role ==
                                    'Técnico(a) de Nível Médio PSB' ||
                                  data.item.user_role ==
                                    'Técnico(a) de Nível Médio PSE' ||
                                  $store.state.user.role_details.name ==
                                    'Coordenador' ||
                                  $store.state.user.role_details.name ==
                                    'Gestor(a)' ||
                                  $store.state.user.role_details.name ==
                                    'Técnico(a) de Nível Superior'))
                            "
                            v-b-tooltip.hover
                            :title="$t('Visualizar e Imprimir')"
                            :to="
                              '/dashboard/violacaodedireitos/show/' +
                              data.item.id
                            "
                            class="px-2 mb-0"
                            size="xs"
                            type="button"
                            variant="primary"
                          >
                            <i class="mdi mdi-eye" />
                          </b-button>
                          <button
                            v-if="user_id == data.item.user_id"
                            class="px-2 mb-0 btn btn-xs btn-success"
                            @click="redirectViolacaodedireitos(data.item.id)"
                          >
                            <i class="mdi mdi-square-edit-outline" />
                          </button>
                        </template>
                        <template v-slot:empty="scope">
                          <div class="text-center my-5">
                            <img
                              :alt="$t('No results')"
                              class="mb-5"
                              src="/img/icons/robot.svg"
                              style="max-height: 165px"
                            />
                            <h3 class="bold">
                              {{ $t("No records found") }}
                            </h3>
                          </div>
                        </template>
                      </b-table>

                      <div class="row align-items-center">
                        <div class="col-lg-6 col-md-12">
                          <div class="form-group d-inline-flex mb-0">
                            <select
                              v-model="perPage"
                              class="form-control"
                              style="width: 70px"
                              v-on:change="getVVD"
                            >
                              <option value="5">5</option>
                              <option value="10">10</option>
                              <option value="25">25</option>
                              <option value="50">50</option>
                            </select>
                          </div>
                          <div class="d-inline-flex ml-2">
                            <b-pagination
                              v-model="page"
                              :per-page="perPage"
                              :total-rows="pagination.total"
                              @change="changePage"
                            />
                          </div>
                        </div>
                        <div class="col-lg-6 col-md-12 mt-4 mt-lg-0">
                          <div class="float-lg-right">
                            {{ $t("Showing page") }}
                            {{ pagination.currentPage }}
                            {{ $t("of") }}
                            {{ pagination.totalPages }}
                            {{ $t("pages in") }}
                            {{ pagination.total }}
                            {{ $t("records") }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <Novo v-else :familia="familia" @voltar="novo_vvd = false" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ModalVerViolacoes :dados="vddSelecionada" :itens="violacoes" />
  </div>
</template>
<script>
import Novo from "./Add";
import ModalVerViolacoes from "./includes/ModalVerViolacoes";

export default {
  components: { Novo, ModalVerViolacoes },
  name: "ViolacaoDeDireitos",
  metaInfo() {
    return {
      title: this.$i18n.t("Situação de Violação de Direitos"),
    };
  },
  data() {
    return {
      showName: false,
      familia: {},
      novo_vvd: false,
      TipoVVDList: [],
      VVDList: [],
      page: 1,
      search: "",
      perPage: 10,
      loadingVVD: true,
      loading: true,
      pagination: {
        currentPage: 0,
        perPage: 0,
        total: 0,
        totalPages: 0,
      },
      violacoes: [],
      vddSelecionada: {},
      user_id: null,
      tecnico_id: null,
      unidade_id: null,
      info_vvd:
        "UTILIZE ESSE QUADRO PARA REGISTRAR SITUAÇÕES QUE FORAM IDENTIFICADAS PELA EQUIPE ONDE HÁ VIOLAÇÃO DE DIREITOS, OU SEJA, ONDE EXISTE A TRANSGRESSÃO AOS DIREITOS FUNDAMENTAIS GARANTIDOS PELAS LEGISLAÇÕES BRASILEIRAS, INDÍCIO OU CONFIRMADO.",
    };
  },
  mounted() {
    this.$route.query.familia_id = this.$route.params.id;
    if (typeof this.$route.query.item === "object") {
      this.familia = this.$route.query.item;
    } else {
      this.getFamilia();
    }
    this.getVVD();
  },
  methods: {
    mostrarNome() {
      this.showName = true;
    },
    ocultarNome() {
      this.showName = false;
    },
    getViolacoes(value, vddSelecionada) {
      this.violacoes = value;
      this.vddSelecionada = vddSelecionada;
      this.$bvModal.show("modalVerViolacoes");
    },
    getVVD() {
      this.loadingVVD = true;
      axios
        .get("api/dashboard/violacaodedireitos", {
          params: {
            id: this.$route.params.id,
            page: this.page,
            search: this.search,
            perPage: this.perPage,
          },
        })
        .then((response) => {
          this.user_id = this.$store.state.user.id;
          this.tecnico_id = this.$store.state.user.tecnico.id;
          this.unidade_id = this.$store.state.user.tecnico.unidade_id;
          this.VVDList = response.data.data;
          this.pagination = response.data.pagination;

          if (this.pagination.totalPages < this.pagination.currentPage) {
            this.page = this.pagination.totalPages;
            this.getVVD();
          } else {
            this.loadingVVD = false;
          }
        })
        .catch(() => {
          this.loadingVVD = false;
        });
    },
    changePage(page) {
      if (
        page > 0 &&
        page <= this.pagination.totalPages &&
        page !== this.page
      ) {
        this.page = page;
        this.getVVD();
      }
    },
    redirectViolacaodedireitos(id) {
      this.$router.push({
        path: `/dashboard/violacaodedireitos/edit/${id}`,
        query: { familia_id: this.$route.query.familia_id },
      });
    },
    getFamilia() {
      axios
        .get("api/dashboard/familias/" + this.$route.query.familia_id)
        .then((response) => {
          this.familia = response.data.data;
          this.$route.query.familia_id = this.familia.id;
          this.loading = false;
        })
        .catch(() => {
          this.$router.push("/dashboard/familias");
        });
    },
  },
};
</script>
